import type { UpgradePreviewEffectiveDiscount } from "@/react/types/Paywalls/Checkout/UpgradePreview";

/** Separate invoice previews can assign different Stripe IDs to the same coupon. */
export const uniqueUpgradeCoupons = (
  discounts: UpgradePreviewEffectiveDiscount[],
) => {
  const seen = new Set<string>();
  return discounts.filter(discount => {
    const identity =
      discount.paywall_coupon_id != null
        ? `coupon:${discount.paywall_coupon_id}`
        : `discount:${discount.discount_id}`;
    if (seen.has(identity)) return false;
    seen.add(identity);
    return true;
  });
};
